// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filters[data-v-1ebc321e] .menu {\n  width: 300px !important;\n}", "",{"version":3,"sources":["webpack://./resources/js/components/logs-managment/index/Index.vue"],"names":[],"mappings":"AACA;EACC,uBAAA;AAAD","sourcesContent":["\n.filters ::v-deep(.menu) {\n\twidth: 300px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
